<template>
  <div class="tradingContent">
    <div v-if="!dialogDetails.show">
       <el-input
            v-model="search.cpmc"
            size="small"
            placeholder="请输入内容"
            style="width: 160px;margin:0 10px 20px 0;"
          ></el-input>
            <el-input
            v-model="search.orderNo"
            size="small"
            style="width: 160px;margin:0 10px 20px 0;"
            placeholder="请输入内容"
          ></el-input>
           <el-input
            v-model="search.jrjgmg"
            size="small"
            style="width: 160px;margin:0 10px 20px 0;"
            placeholder="请输入内容"
          ></el-input>
           <el-select
            ref="select"
            v-model="search.status"
            placeholder="状态"
            size="small"
            style="width: 160px;margin:0 10px 20px 0;"
            filterable
            clearable
            @change="handleQuery"
          >
            <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.labal"
              :value="item.status"
            />
          </el-select>
                  <el-button icon="el-icon-search" size="small" @click="handleQuery"
            >查询</el-button
          >
          <el-button type="info" icon="el-icon-refresh" size="small" @click="refresh"
            >重置</el-button
          >
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      :highlight-current-row="true"
      stripe
      style="width: 100%; text-algin: center;border-radius: 16px;"
      v-if="!dialogDetails.show"
    >
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column
        prop="orderNo"
        label="订单编号"
        width="210"
        align="center"
      />
      <el-table-column
        prop="cpmc"
        label="产品名称"
        width="150"
        align="center"
      />
        <el-table-column prop="qymc" label="申请企业" />
        <el-table-column prop="username" label="企业联系人及电话">
          <template slot-scope="scope">
            <span>{{ scope.row.username +'  '+ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="khjl" label="客户经理及电话">
          <template slot-scope="scope">
            <span>{{ scope.row.khjl +'  '+ scope.row.lxrdh }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" width="150" >
          <template slot-scope="scope">
            <el-button size="small" type="info" plain v-if="scope.row.status==0">取消订单</el-button>
            <el-button size="small" type="primary" plain v-else-if="scope.row.status==1">待审核</el-button>
            <el-button size="small" type="danger" plain v-else-if="scope.row.status==2">审核不通过</el-button>
            <el-button size="small" type="warning" plain v-else-if="scope.row.status==3">授信中</el-button>
            <el-button size="small" type="primary" plain v-else-if="scope.row.status==4">授信待确认</el-button>
            <el-button size="small" type="danger" plain v-else-if="scope.row.status==5">金融机构授信不通过</el-button>
            <el-button size="small" type="success" plain v-else-if="scope.row.status==6">同意授信</el-button>
            <el-button size="small" type="danger" plain v-else-if="scope.row.status==7">企业不同意授信</el-button>
            <el-button size="small" type="info" plain v-else-if="scope.row.status==8">撮合成功（已完成）</el-button>
          </template>
        </el-table-column>
      <el-table-column
        prop="a11"
        label="操作"
        width="150"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="(scope.row.status<=6) && (scope.row.status!=0) "
            size="small"
            @click="handleCancel(scope.row)"
            >取消订单</el-button>

          <el-button
            type="text"
            v-if="scope.row.status==4"
            size="small"
            @click="handleTrading(scope.row)"
            >授信确认</el-button>

          <el-button
            type="text"
            v-if="scope.row.status==8"
            size="small"
            @click="handleContract(scope.row)"
            >查看合同</el-button>

          <el-button
            type="text"
            size="small"
            @click="handleDetails(scope.row)"
            >详情</el-button>

        </template>
      </el-table-column>
    </el-table>
    <div class="pagination"  v-if="!dialogDetails.show">
      <el-pagination
        background
        layout="total, sizes,prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="page.current"
        :page-size.sync="page.size"
        :total="page.total"
        @current-change="queryData"
        @size-change="handleQuery"
      />
    </div>

    <!-- 订单详情（内联模式） -->
    <order-details
      v-if="dialogDetails.show"
      :show="dialogDetails.show"
      :title="dialogDetails.title"
      :type="dialogDetails.type"
      :view-data="dialogDetails.viewData"
      @closeDialog="closeDialogDetails"
    />

    <!-- 授信确认弹框 -->
    <credit-confirm-dialog
      :show="creditDialog.show"
      :row-data="creditDialog.rowData"
      @closeDialog="closeCreditDialog"
    />
  </div>
</template>
<script>
import orderDetails from "./orderDetails.vue";
import creditConfirmDialog from "./creditConfirmDialog.vue";
import { getProductOrderList } from "@/api/index";
import { getDetailPortals } from "./viewApi";
export default {
  components: {
    orderDetails,
    creditConfirmDialog,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_API,
      page: {
        size: 10,
        total: 0,
        current: 1,
      },
      dialogDetails: {
        show: false,
        hideUnit: false,
        viewData: {},
        title: "",
      },
      creditDialog: {
        show: false,
        rowData: {},
      },
      tableData: [],
      search: {
        cpmc: null,
        status: null,
        orderNo: null,
        jrjgmg: null,
      },
      busFile:{},
      statusList: [
        {
          status: 0,
          labal: "取消订单",
        },
        {
          status: 1,
          labal: "待审核",
        },
        {
          status: 2,
          labal: "审核不通过",
        },
        {
          status: 3,
          labal: "授信中",
        },
        {
          status: 4,
          labal: "授信待确认",
        },
        {
          status: 5,
          labal: "金融机构授信不通过",
        },
        {
          status: 6,
          labal: "同意授信",
        },
        {
          status: 7,
          labal: "企业不同意授信",
        },
        {
          status: 8,
          labal: "撮合成功（已完成）",
        },
      ],
    };
  },
  created() {
    this.queryData();
  },
  mounted() {
    // 从消息跳转过来时，直接打开对应订单详情
    this.$nextTick(() => {
      if (this.$route.query.highlightId) {
        this.openDetailById(this.$route.query.highlightId);
      }
    });
    // 监听从铃铛直接打开详情的事件
    window.addEventListener('openOrderDetail', this.handleOpenOrderDetail);
  },
  beforeDestroy() {
    window.removeEventListener('openOrderDetail', this.handleOpenOrderDetail);
  },
  methods: {
    handleOpenOrderDetail(event) {
      const id = event.detail.id;
      this.openDetailById(id);
    },
    openDetailById(id) {
      const targetId = Number(id);
      const index = this.tableData.findIndex(item => item.id === targetId);
      if (index !== -1) {
        this.handleDetails(this.tableData[index]);
      } else {
        this.findAndOpenDetail(targetId);
      }
    },
    findAndOpenDetail(targetId) {
      let currentPage = 1;
      const pageSize = this.page.size;
      const search = () => {
        let params = {
          ...this.search,
          current: currentPage,
          size: pageSize,
        };
        getProductOrderList(params).then(res => {
          if (res.data) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
            this.page.current = currentPage;
            const index = this.tableData.findIndex(item => item.id === targetId);
            if (index !== -1) {
              this.$nextTick(() => {
                this.handleDetails(this.tableData[index]);
              });
            } else if (currentPage * pageSize < res.data.total) {
              currentPage++;
              search();
            } else {
              this.$message.warning('未找到对应记录');
            }
          }
        });
      };
      search();
    },
    async handleContract(row){
      let res = await getDetailPortals({ id: row.id });
      if (res.data.busFiles.length>0) {
        this.busFile = res.data.busFiles[0].url;
        window.open(this.baseUrl + res.data.busFiles[0].url, '_blank');
      }else{
         this.$baseMessage("未上传合同！", "error");
      }
    },
    /** 打开授信确认弹框 */
    handleTrading(row) {
      this.creditDialog.rowData = { ...row };
      this.creditDialog.show = true;
    },

    /** 关闭授信确认弹框 */
    closeCreditDialog(needRefresh) {
      this.creditDialog.show = false;
      this.creditDialog.rowData = {};
      if (needRefresh) {
        this.queryData();
      }
    },
    handleCancel(row){
      this.dialogDetails.type = 2;
      this.dialogDetails.title = '取消订单';
      this.dialogDetails.viewData = { ...row };
      this.dialogDetails.show = true;
    },
    //详情
    handleDetails(row) {
      this.dialogDetails.title = '详情';
      this.dialogDetails.viewData = { ...row };
      this.dialogDetails.type = (row.status==0) ? 3 : 1;
      this.dialogDetails.show = true;
    },
    // 关闭详情弹窗
    closeDialogDetails(needRefresh) {
      this.dialogDetails.show = false;
      this.dialogDetails.viewData = {};
      this.dialogDetails.title = "";
      this.queryData();
    },
    handleEdit() {},
    handleQuery() {
      this.page.current = 1;
      this.queryData();
    },
    refresh() {
      this.page.current = 1;
      this.search = {
        cpmc: null,
        status: null,
        orderNo: null,
        jrjgmg: null,
      };
      this.queryData();
    },
    async queryData() {
      let params = {
        ...this.search,
        ...this.page,
      };
      let res = await getProductOrderList(params);
      if (res.data) {
        this.tableData = res.data.records;
        this.page.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;

  ::v-deep .el-form-item {
    margin-bottom: 0;
    margin-right: 16px;
  }

  ::v-deep .el-form-item__label {
    width: 80px;
    text-align: right;
    padding-right: 8px;
  }

  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
